import { Component, Input, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { INJECT_TYPE } from 'src/app/constants';
import { DialogItem } from 'src/app/dialog-item';
import { Enums } from '../enums';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {
  private activeModal = inject(NgbActiveModal);
  private enums = inject(Enums);

  @Input() message: string;
  @Input() injectContent: DialogItem[];
  @Input() needExtraConfirm = false;
  @Input() extraConfirmMessage = "I understand and confirm all my actions";
  @Input() confirmationType: number;

  disableConfirm = signal<boolean>(false);

  agreed = false;
  INJECT_TYPE = INJECT_TYPE;

  checkType() {
    switch (this.confirmationType) {
      case this.enums.WARNING_CONFIRMATION:
        return 'warning';
      case this.enums.DANGER_CONFIRMATION:
        return 'danger';
      case this.enums.INFO_CONFIRMATION:
      default:
        return 'info';
    }
  }

  setConfirmation(confirm: boolean) {
    this.activeModal.close(confirm);
  }
}
